import { render, staticRenderFns } from "./tileButtonGridBlock.vue?vue&type=template&id=7aea3fca&scoped=true&"
import script from "./tileButtonGridBlock.vue?vue&type=script&lang=js&"
export * from "./tileButtonGridBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aea3fca",
  null
  
)

export default component.exports